var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "permission",
              rawName: "v-permission",
              value: "newsletter_workflows.create",
              expression: "'newsletter_workflows.create'"
            },
            {
              name: "ripple",
              rawName: "v-ripple.400",
              value: "rgba(255, 255, 255, 0.15)",
              expression: "'rgba(255, 255, 255, 0.15)'",
              modifiers: { "400": true }
            }
          ],
          attrs: { variant: "primary" },
          on: { click: _vm.addNew }
        },
        [
          _c("feather-icon", {
            staticClass: "mr-50",
            attrs: { icon: "PlusIcon" }
          }),
          _c("span", { staticClass: "align-middle" }, [
            _vm._v(_vm._s(_vm.$t("AddNew")))
          ])
        ],
        1
      ),
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          route_name: "newsletter_workflows",
          route_grid_path: "/grid",
          order_column: "name"
        },
        scopedSlots: _vm._u([
          {
            key: "gridThead",
            fn: function() {
              return [
                _c("vs-th", { key: "id", attrs: { "sort-key": "id" } }, [
                  _vm._v("ID")
                ]),
                _c("vs-th", { key: "name", attrs: { "sort-key": "name" } }, [
                  _vm._v(_vm._s(_vm.$t("newsletter.workflow.name")))
                ]),
                _c(
                  "vs-th",
                  { key: "description", attrs: { "sort-key": "description" } },
                  [_vm._v(_vm._s(_vm.$t("newsletter.workflow.description")))]
                )
              ]
            },
            proxy: true
          },
          {
            key: "gridData",
            fn: function(props) {
              return _vm._l(props.data, function(tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _c("vs-td", { key: "id", attrs: { width: "5%" } }, [
                      _c("div", [_vm._v(" " + _vm._s(tr.id) + " ")])
                    ]),
                    _c("vs-td", { key: "name", attrs: { width: "30%" } }, [
                      _c("div", [_vm._v(" " + _vm._s(tr.name))])
                    ]),
                    _c(
                      "vs-td",
                      { key: "description", attrs: { width: "40%" } },
                      [
                        _c("div", {
                          directives: [
                            {
                              name: "html-safe",
                              rawName: "v-html-safe",
                              value: tr.description,
                              expression: "tr.description"
                            }
                          ]
                        })
                      ]
                    ),
                    _c("vs-td", { attrs: { width: "10%" } }, [
                      _c(
                        "div",
                        { staticClass: "flex flex-row gap-2" },
                        [
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "newsletter_workflows.edit",
                                expression: "'newsletter_workflows.edit'"
                              },
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true }
                              }
                            ],
                            staticClass:
                              "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                            attrs: {
                              icon: "EditIcon",
                              title: _vm.$t("action.edit")
                            },
                            on: {
                              click: function($event) {
                                return props.edit(props.data[indextr].id)
                              }
                            }
                          }),
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "newsletter_workflows.detail",
                                expression: "'newsletter_workflows.detail'"
                              },
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true }
                              }
                            ],
                            staticClass:
                              "h-5 w-5 mb-1 mr-1 stroke-current text-success",
                            attrs: {
                              icon: "EyeIcon",
                              title: _vm.$t("action.detail")
                            },
                            on: {
                              click: function($event) {
                                return _vm.detail(props.data[indextr])
                              }
                            }
                          }),
                          _c(
                            "vs-dropdown",
                            {
                              staticClass: "cursor-pointer",
                              attrs: {
                                "vs-custom-content": "",
                                "vs-trigger-click": ""
                              }
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "h-5 w-5 mb-1 mr-1 stroke-current",
                                attrs: {
                                  type: "filled",
                                  icon: "MoreVerticalIcon"
                                }
                              }),
                              _c(
                                "vs-dropdown-menu",
                                [
                                  _c(
                                    "vs-dropdown-item",
                                    {
                                      directives: [
                                        {
                                          name: "permission",
                                          rawName: "v-permission",
                                          value: "newsletter_workflows.clone",
                                          expression:
                                            "'newsletter_workflows.clone'"
                                        }
                                      ]
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex",
                                          staticStyle: { width: "150px" },
                                          on: {
                                            click: function($event) {
                                              return _vm.confirmClone(
                                                props.data[indextr]
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "w-2/12" },
                                            [
                                              _c("feather-icon", {
                                                attrs: {
                                                  icon: "GridIcon",
                                                  svgClasses:
                                                    "h-5 w-5 mb-1 stroke-current text-primary"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "w-10/12" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex bg-gray-200 float-left text-primary"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t("action.clone")
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "vs-dropdown-item",
                                    {
                                      directives: [
                                        {
                                          name: "permission",
                                          rawName: "v-permission",
                                          value: "newsletter_workflows.delete",
                                          expression:
                                            "'newsletter_workflows.delete'"
                                        }
                                      ]
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex",
                                          staticStyle: { width: "150px" },
                                          on: {
                                            click: function($event) {
                                              return _vm.confirmDelete(
                                                props.data[indextr]
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "w-2/12" },
                                            [
                                              _c("feather-icon", {
                                                attrs: {
                                                  icon: "Trash2Icon",
                                                  svgClasses:
                                                    "h-5 w-5 mb-1 stroke-current text-danger"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "w-10/12" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex bg-gray-200 float-left text-danger"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t("action.delete")
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              })
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }